
// import React, { useEffect, useState } from "react";
// import { InverterDetail } from "../../../../../../api/Api";

// import "./Tab5Content.css";
// import { Fullscreen, Refresh } from "@mui/icons-material"; // Import icons
// import IconButton from "@mui/material/IconButton";
// import UpdateInverter from "./UpdateInverter";

// export default function DashboardInverterData() {
//     const [logData, setLogData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]); // State for filtered data
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [searchQuery, setSearchQuery] = useState(""); // State for search input


//     // this is modal code
//     const [showModal, setShowModal] = useState(false);
//     const [selectedUser, setSelectedUser] = useState(null);

//     const [currentPage, setCurrentPage] = useState(1);
//     const rowsPerPage = 10;

//     const [credentials] = useState({
//         LOGIN_ID: localStorage.getItem("LoginID") || "",
//         LOC_CODE: localStorage.getItem("LCODE") || "",
//         PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//         WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//     });

//     const fetchLogData = async () => {
//         setLoading(true);
//         setError(null);
//         setLogData([]);
//         try {
//             const res = await InverterDetail(credentials);
//             if (res?.data && Array.isArray(res.data)) {
//                 setLogData(res.data);
//                 setFilteredData(res.data); // Initialize filtered data
//             } else {
//                 setLogData([]);
//                 setFilteredData([]);
//             }
//         } catch (err) {
//             console.error("Error fetching data:", err);
//             setError("Failed to fetch data.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchLogData();
//     }, [credentials.LOGIN_ID]);

//     const handleSearch = () => {
//         const filtered = logData.filter((item) => {
//             return (
//                 Object.values(item)
//                     .join(" ")
//                     .toLowerCase()
//                     .includes(searchQuery.toLowerCase())
//             );
//         });
//         setFilteredData(filtered);
//         setCurrentPage(1); // Reset to the first page
//     };



//     const indexOfLastRow = currentPage * rowsPerPage;
//     const indexOfFirstRow = indexOfLastRow - rowsPerPage;
//     const currentRows = filteredData.slice(indexOfFirstRow, indexOfLastRow);
//     const totalPages = Math.ceil(filteredData.length / rowsPerPage);

//     const handlePageChange = (page) => {
//         if (page >= 1 && page <= totalPages) {
//             setCurrentPage(page);
//         }
//     };


//     // This code for update modal

//     const handleOpenModal = (userData) => {
//         setSelectedUser(userData);
//         setShowModal(true);
//     };

//     const handleClose = () => {
//         setShowModal(false);
//         setSelectedUser(null);
//     };

//     const handleUpdate = (updatedUser) => {
//         setLogData((prevData) =>
//             prevData.map((user) =>
//                 user.USER_ID === updatedUser.USER_ID ? updatedUser : user
//             )
//         );
//         handleClose();
//     };

//     return (

//         <>
//             <div className="w-100 my-1" style={{backgroundColor:"black"}}>
//                 <div className="row">
//                     <div className="col-md-12">
//                         {loading && <p>Loading...</p>}
//                         {error && <p style={{ color: "red" }}>{error}</p>}
//                         <div
//                             className="w-100"
//                             style={{
//                                 backgroundColor: "black",
//                                 borderBottom: "2px solid #dee2e6",
//                             }}
//                         >
//                             <div className="d-flex justify-content-between align-items-center px-3">
//                                 <h6
//                                     style={{
//                                         margin: 0,
//                                         fontWeight: "bold",
//                                         color: "white",
//                                     }}
//                                 >
//                                     Inverter Details
//                                 </h6>
//                                 <div className="d-flex align-items-center">
//                                     {/* Search Input */}
//                                     <input
//                                         type="text"
//                                         className="form-control form-control-sm me-2"
//                                         placeholder="Search..."
//                                         value={searchQuery}
//                                         onChange={(e) => setSearchQuery(e.target.value)}
//                                         style={{ maxWidth: "200px", height: "2.5rem" }}
//                                     />
//                                     {/* Search Button */}
//                                     <button
//                                         className="btn btn-primary "
//                                         onClick={handleSearch}
//                                         // style={{ width: "5rem", height: "2.2rem" }}
//                                     >
//                                         Search
//                                     </button>
//                                     {/* Refresh Button */}
//                                     <IconButton onClick={fetchLogData}>
//                                         <Refresh />
//                                     </IconButton>
//                                     {/* Fullscreen Button */}
//                                     <IconButton>
//                                         <Fullscreen />
//                                     </IconButton>
//                                 </div>
//                             </div>
//                         </div>

//                         <div
//                             className="table-responsive"
//                             style={{
//                                 border: "1px solid #dee2e6",
//                                 borderTop: "none",
//                             }}
//                         >
//                             <table className="table table-striped">
//                                 <thead>
//                                     <tr>
//                                         <th>SN</th>
//                                         <th>ID</th>
//                                         <th>S_ID</th>
//                                         <th>MAC_ID</th>
//                                         <th>NAME</th>
//                                         <th>Make</th>
//                                         <th>Model No</th>
//                                         <th>Capacity (kWP)</th>
//                                         <th>Day kWh</th>
//                                         <th>Total kWh</th>
//                                         <th>Date(Time)</th>
//                                         <th>kW</th>
//                                         <th>Latitude</th>
//                                         <th>Longitude</th>
//                                         <th>Alarm/Status</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {currentRows.length > 0 ? (
//                                         currentRows.map((log, index) => (
//                                             <tr key={index}>
//                                                 <td>{indexOfFirstRow + index + 1}</td>
//                                                 {/* <td>{log.FEEDER_ID}</td> */}

//                                                 <td
//                                                     className="text-primary text-decoration-none"
//                                                     style={{ cursor: "pointer" }}
//                                                     onClick={() => handleOpenModal(log)}
//                                                 >
//                                                     {log.FEEDER_ID}
//                                                 </td>

//                                                 <td>{log.SID}</td>
//                                                 <td>{log.MAC_ID}</td>
//                                                 <td>{log.NAME}</td>
//                                                 <td>{log.MAKE}</td>
//                                                 <td>{log.MODEL_NO}</td>
//                                                 <td>{log.KWP}</td>
//                                                 <td>{log.DAY_KWH}</td>
//                                                 <td>{log.TOT_GEN}</td>
//                                                 <td>{log.E_DATE}</td>
//                                                 <td>{log.KW}</td>
//                                                 <td>{log.Latitude}</td>
//                                                 <td>{log.Longitude}</td>
//                                                 <td>{log.ALARM}</td>
//                                             </tr>
//                                         ))
//                                     ) : (
//                                         <tr>
//                                             <td colSpan="13">No data available</td>
//                                         </tr>
//                                     )}
//                                 </tbody>
//                             </table>
//                         </div>

//                         <div className="d-flex justify-content-center my-3">
//                             <button
//                                 className="btn btn-secondary btn-sm mx-1"
//                                 onClick={() => handlePageChange(currentPage - 1)}
//                                 disabled={currentPage === 1}
//                             >
//                                 Previous
//                             </button>
//                             {[...Array(totalPages).keys()].map((num) => (
//                                 <button
//                                     key={num}
//                                     className={`btn btn-sm mx-1 ${currentPage === num + 1
//                                         ? "btn-primary"
//                                         : "btn-outline-primary"
//                                         }`}
//                                     onClick={() => handlePageChange(num + 1)}
//                                 >
//                                     {num + 1}
//                                 </button>
//                             ))}
//                             <button
//                                 className="btn btn-secondary btn-sm mx-1"
//                                 onClick={() => handlePageChange(currentPage + 1)}
//                                 disabled={currentPage === totalPages}
//                             >
//                                 Next
//                             </button>
//                         </div>
//                     </div>
//                 </div>

//             </div>


//             {/* Pass Props to UpdateComponent */}
//             {showModal && selectedUser && (
//                 <UpdateInverter
//                     show={showModal}
//                     handleClose={handleClose}
//                     userData={selectedUser}
//                     handleUpdate={handleUpdate}
//                 />
//             )}
//         </>

//     );
// }

//2. React Icon Cross and Tick

// import React, { useEffect, useState } from "react";
// import { InverterDetail } from "../../../../../../api/Api";

// // import "./Tab5Content.css";
// import { Fullscreen, Refresh } from "@mui/icons-material";
// import IconButton from "@mui/material/IconButton";
// import UpdateInverter from "./UpdateInverter";
// import { ImCross } from "react-icons/im";
// import { PiCheckFatFill } from "react-icons/pi";

// export default function DashboardInverterData() {
//     const [logData, setLogData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [searchQuery, setSearchQuery] = useState("");

//     const [showModal, setShowModal] = useState(false);
//     const [selectedUser, setSelectedUser] = useState(null);

//     const [credentials] = useState({
//         LOGIN_ID: localStorage.getItem("LoginID") || "",
//         LOC_CODE: localStorage.getItem("LCODE") || "",
//         PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//         WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//     });

//     const fetchLogData = async () => {
//         setLoading(true);
//         setError(null);
//         setLogData([]);
//         try {
//             const res = await InverterDetail(credentials);
//             if (res?.data && Array.isArray(res.data)) {
//                 setLogData(res.data);
//                 setFilteredData(res.data);
//             } else {
//                 setLogData([]);
//                 setFilteredData([]);
//             }
//         } catch (err) {
//             console.error("Error fetching data:", err);
//             setError("Failed to fetch data.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchLogData();
//     }, [credentials.LOGIN_ID]);

//     const handleSearch = () => {
//         const filtered = logData.filter((item) =>
//             Object.values(item).join(" ").toLowerCase().includes(searchQuery.toLowerCase())
//         );
//         setFilteredData(filtered);
//     };

//     const handleOpenModal = (userData) => {
//         setSelectedUser(userData);
//         setShowModal(true);
//     };

//     const handleClose = () => {
//         setShowModal(false);
//         setSelectedUser(null);
//     };

//     const handleUpdate = (updatedUser) => {
//         setLogData((prevData) =>
//             prevData.map((user) =>
//                 user.USER_ID === updatedUser.USER_ID ? updatedUser : user
//             )
//         );
//         handleClose();
//     };

//     return (
//         <>
//             <div className="w-100 my-0" style={{ backgroundColor: "black" }}>
//                 <div className="row">
//                     <div className="col-md-12">
//                         {loading && <p>Loading...</p>}
//                         {error && <p style={{ color: "red" }}>{error}</p>}

//                         <div className="w-100" style={{ borderBottom: "0px solid #dee2e6" }}>

//                             <div className="d-flex justify-content-between align-items-center px-0" >
//                                 <h6 style={{ margin: 0, fontWeight: "bold", color: "white" }}>
//                                     Inverter Details
//                                 </h6>
//                                 <div className="d-flex align-items-center">
//                                     <input
//                                         type="text"
//                                         className="form-control form-control-sm me-2"
//                                         placeholder="Search..."
//                                         value={searchQuery}
//                                         onChange={(e) => setSearchQuery(e.target.value)}
//                                         style={{ maxWidth: "200px", height: "2.5rem" }}
//                                     />
//                                     <button
//                                         className="btn btn-primary"
//                                         onClick={handleSearch}
//                                     >
//                                         Search
//                                     </button>
//                                     <IconButton onClick={fetchLogData}>
//                                         <Refresh />
//                                     </IconButton>
//                                     <IconButton>
//                                         <Fullscreen />
//                                     </IconButton>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="table-responsive" style={{ borderTop: "0px", margin: "0px" }}

//                         >
//                             <table className="table table-striped">
//                                 <thead>
//                                     <tr>
//                                         <th>SN</th>
//                                         <th>ID</th>
//                                         <th>S_ID</th>
//                                         <th>MAC_ID</th>
//                                         <th>NAME</th>
//                                         <th>Make</th>
//                                         <th>Model No</th>
//                                         <th>Capacity (kWP)</th>
//                                         <th>Day kWh</th>
//                                         <th>Total kWh</th>
//                                         <th>Date(Time)</th>
//                                         <th>kW</th>
//                                         {/* <th>Latitude</th>
//                                         <th>Longitude</th> */}
//                                         <th>Alarm/Status</th>
//                                         <th>Network</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {filteredData.length > 0 ? (
//                                         filteredData.map((log, index) => (
//                                             <tr key={index}>
//                                                 <td>{index + 1}</td>
//                                                 <td
//                                                     className="text-primary text-decoration-none"
//                                                     style={{ cursor: "pointer" }}
//                                                     onClick={() => handleOpenModal(log)}
//                                                 >
//                                                     {log.FEEDER_ID}
//                                                 </td>
//                                                 <td>{log.SID}</td>
//                                                 <td>{log.MAC_ID}</td>
//                                                 <td>{log.NAME}</td>
//                                                 <td>{log.MAKE}</td>
//                                                 <td>{log.MODEL_NO}</td>
//                                                 <td>{log.KWP}</td>
//                                                 <td>{log.DAY_KWH}</td>
//                                                 <td>{log.TOT_GEN}</td>
//                                                 <td>{log.E_DATE}</td>
//                                                 <td>{log.KW}</td>
//                                                 {/* <td>{log.Latitude}</td>
//                                                 <td>{log.Longitude}</td> */}
//                                                 <td>{log.ALARM}</td>
//                                                 <td
//                                                     style={{
//                                                         color:
//                                                             Number(log.KW) === 0 ||
//                                                                 (new Date() - new Date(log.NETWORK)) > 10 * 60 * 1000
//                                                                 ? "red"
//                                                                 : "green",
//                                                         fontWeight: "bold",
//                                                     }}
//                                                 >
//                                                     {Number(log.KW) === 0 ||
//                                                         (new Date() - new Date(log.NETWORK)) > 10 * 60 * 1000 ? (
//                                                         <>
//                                                             <ImCross /> &nbsp; {log.NETWORK}
//                                                         </>
//                                                     ) : (
//                                                         <>
//                                                             <PiCheckFatFill /> &nbsp; {log.NETWORK}
//                                                         </>
//                                                     )}
//                                                 </td>

//                                             </tr>
//                                         ))
//                                     ) : (
//                                         <tr>
//                                             <td colSpan="15" className="text-center">No data available</td>
//                                         </tr>
//                                     )}
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {showModal && selectedUser && (
//                 <UpdateInverter
//                     show={showModal}
//                     handleClose={handleClose}
//                     userData={selectedUser}
//                     handleUpdate={handleUpdate}
//                 />
//             )}
//         </>
//     );
// }


//3. MUI ICONS

import React, { useEffect, useState } from "react";
import { InverterDetail } from "../../../../../../api/Api";

// import "./Tab5Content.css";
import { Fullscreen, Refresh } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import UpdateInverter from "./UpdateInverter";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function parseCustomDate(dateStr) {
    // format: DD-MM-YYYY HH:mm:ss
    const [datePart, timePart] = dateStr.split(" ");
    const [day, month, year] = datePart.split("-").map(Number);
    const [hour, minute, second] = timePart.split(":").map(Number);
    return new Date(year, month - 1, day, hour, minute, second);
}

function parseCustomDate2(dateStr) {
    // format: DD-MMM-YYYY HH:mm:ss
    const [datePart, timePart] = dateStr.split(" ");
    const [day, monthStr, year] = datePart.split("-");
    const [hour, minute, second] = timePart.split(":").map(Number);
  
    const months = {
      Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
      Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
    };
  
    return new Date(
      parseInt(year, 10),
      months[monthStr],
      parseInt(day, 10),
      hour,
      minute,
      second
    );
  }
  

export default function DashboardInverterData() {
    const [logData, setLogData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");

    const [showModal, setShowModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    const [credentials] = useState({
        LOGIN_ID: localStorage.getItem("LoginID") || "",
        LOC_CODE: localStorage.getItem("LCODE") || "",
        PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
        WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
    });

    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);
        try {
            const res = await InverterDetail(credentials);
            if (res?.data && Array.isArray(res.data)) {
                setLogData(res.data);
                setFilteredData(res.data);
            } else {
                setLogData([]);
                setFilteredData([]);
            }
        } catch (err) {
            console.error("Error fetching data:", err);
            setError("Failed to fetch data.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLogData();
    }, [credentials.LOGIN_ID]);

    const handleSearch = () => {
        const filtered = logData.filter((item) =>
            Object.values(item).join(" ").toLowerCase().includes(searchQuery.toLowerCase())
        );
        setFilteredData(filtered);
    };

    const handleOpenModal = (userData) => {
        setSelectedUser(userData);
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
        setSelectedUser(null);
    };

    const handleUpdate = (updatedUser) => {
        setLogData((prevData) =>
            prevData.map((user) =>
                user.USER_ID === updatedUser.USER_ID ? updatedUser : user
            )
        );
        handleClose();
    };

    return (
        <>
            <div className="w-100 my-0" style={{ backgroundColor: "black" }}>
                <div className="row">
                    <div className="col-md-12">
                        {loading && <p>Loading...</p>}
                        {error && <p style={{ color: "red" }}>{error}</p>}

                        <div className="w-100" style={{ borderBottom: "0px solid #dee2e6" }}>

                            <div className="d-flex justify-content-between align-items-center px-0" >
                                <h6 style={{ margin: "6px", fontWeight: "bold", color: "white" }}>
                                    Inverter Details
                                </h6>
                                <div className="d-flex align-items-center">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm me-2"
                                        placeholder="Search..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        style={{ maxWidth: "200px", height: "2.5rem" }}
                                    />
                                    <button
                                        className="btn btn-primary"
                                        onClick={handleSearch}
                                    >
                                        Search
                                    </button>
                                    <IconButton onClick={fetchLogData}>
                                        <Refresh style={{ color: "white" }} />
                                    </IconButton>
                                    <IconButton>
                                        <Fullscreen />
                                    </IconButton>
                                </div>
                            </div>
                        </div>

                        <div className="table-responsive" style={{ borderTop: "0px", margin: "0px" }}

                        >
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>SN</th>
                                        <th>ID</th>
                                        <th>S_ID</th>
                                        <th>MAC_ID</th>
                                        <th>NAME</th>
                                        <th>Make</th>
                                        <th>Model No</th>
                                        <th>Capacity (kWP)</th>
                                        <th>Day kWh</th>
                                        <th>Total kWh</th>
                                        <th>Date(Time)</th>
                                        <th>kW</th>
                                        {/* <th>Latitude</th>
                                        <th>Longitude</th> */}
                                        <th>Alarm/Status</th>
                                        <th>Network</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.length > 0 ? (
                                        filteredData.map((log, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td
                                                    className="text-primary text-decoration-none"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleOpenModal(log)}
                                                >
                                                    {log.FEEDER_ID}
                                                </td>
                                                <td>{log.SID}</td>
                                                <td>{log.MAC_ID}</td>
                                                <td>{log.NAME}</td>
                                                <td>{log.MAKE}</td>
                                                <td>{log.MODEL_NO}</td>
                                                <td>{log.KWP}</td>
                                                <td>{log.DAY_KWH}</td>
                                                <td>{log.TOT_GEN}</td>
                                                <td
                                                    className={
                                                        Number(log.KW) === 0 &&
                                                            (new Date() - parseCustomDate2(log.E_DATE)) > 10 * 60 * 1000
                                                            ? "blink"
                                                            : ""
                                                    }
                                                    style={{
                                                        color:
                                                            Number(log.KW) === 0 &&
                                                                (new Date() - parseCustomDate2(log.E_DATE)) > 10 * 60 * 1000
                                                                ? "red"
                                                                : "green",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {log.E_DATE}
                                                </td>

                                                {/* <td>{log.E_DATE}</td> */}
                                                <td>{log.KW}</td>
                                                {/* <td>{log.Latitude}</td>
                                                <td>{log.Longitude}</td> */}
                                                <td>{log.ALARM}</td>
                                                {/* <td
                                                    style={{
                                                        color:
                                                          Number(log.KW) === 0 &&
                                                          (new Date() - new Date(log.NETWORK)) > 10 * 60 * 1000
                                                            ? "red"
                                                            : "green",
                                                        fontWeight: "bold",
                                                      }}
                                                      
                                                >
                                                    {Number(log.KW) === 0 &&
                                                        (new Date() - new Date(log.NETWORK)) > 10 * 60 * 1000 ? (
                                                        <>
                                                            <CancelIcon style={{fontSize:"1.7rem"}} /> &nbsp; {log.NETWORK}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <CheckCircleIcon  style={{fontSize:"1.7rem"}}/> &nbsp; {log.NETWORK}
                                                        </>
                                                    )}
                                                </td> */}

                                                <td
                                                    className={
                                                        Number(log.KW) === 0 &&
                                                            (new Date() - parseCustomDate(log.NETWORK)) > 11 * 60 * 1000
                                                            ? "blink"
                                                            : ""
                                                    }
                                                    style={{
                                                        color:
                                                            Number(log.KW) === 0 &&
                                                                (new Date() - parseCustomDate(log.NETWORK)) > 11 * 60 * 1000
                                                                ? "red"
                                                                : "green",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {Number(log.KW) === 0 &&
                                                        (new Date() - parseCustomDate(log.NETWORK)) > 11 * 60 * 1000 ? (
                                                        <>
                                                            <CancelIcon style={{ fontSize: "1.7rem" }} /> &nbsp; {log.NETWORK}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <CheckCircleIcon style={{ fontSize: "1.7rem" }} /> &nbsp; {log.NETWORK}
                                                        </>
                                                    )}
                                                </td>


                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="15" className="text-center">No data available</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {showModal && selectedUser && (
                <UpdateInverter
                    show={showModal}
                    handleClose={handleClose}
                    userData={selectedUser}
                    handleUpdate={handleUpdate}
                />
            )}
        </>
    );
}
